





















import { Component, Vue } from 'vue-property-decorator';
import { UtilService, userSvc } from '@/services';
import { Response } from '@/types';
import { Notification } from 'element-ui';

@Component({
  name: 'forgot-form'
})
export default class ForgotForm extends Vue {
  private email: string = '';
  private emailState: boolean | null = null;
  private isLoading: boolean = false;

  /**
   * onSubmit
   */
  async onSubmit(e: Event) {
    e.preventDefault();

    if (this.validate()) {
      this.isLoading = true;
      try {
        const resp: Response = await userSvc.forgotPassword(this.email);
        Notification.info(resp.message);
        if (resp.status === 'error') {
          Notification.error(resp.message);
        } else {
          Notification.success(resp.message);
          this.$router.push({ name: 'login' });
        }
      } catch (e) {
        this.isLoading = false;
      }
      this.isLoading = false;
    } else {
      return false;
    }
  }

  validate() {
    let pass = true;
    if (UtilService.validateEmail(this.email)) {
      this.emailState = true;
    } else {
      pass = false;
      this.emailState = false;
      this.$message.error('Invalid email');
    }
    return pass;
  }
}
